import { render, staticRenderFns } from "./IconSvgBubble.vue?vue&type=template&id=4befb438&scoped=true&"
import script from "./IconSvgBubble.vue?vue&type=script&lang=js&"
export * from "./IconSvgBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4befb438",
  null
  
)

export default component.exports